export enum WebDPrivilege {
  Login = 0,
  ViewInbox = 1,
  ViewQCHold = 2,
  ViewArchive = 3,
  ViewJobSummary = 4,
  ViewFaxSummary = 5,
  ViewDictationInstructions = 6,

  DocumentsViewInbox = 100,
  DocumentsDownloadInbox = 101,
  DocumentsPrintInbox = 102,
  DocumentsModifyInbox = 103,
  DocumentsApproveInbox = 104,
  DocumentsReleaseQCHold = 105,
  DocumentsFax = 106,
  DocumentsViewHistory = 107,
  DocumentsModifyJobStatus = 108,
  DocumentsViewQCHold = 109,
  DocumentsDownloadQCHold = 110,
  DocumentsPrintQCHold = 111,
  DocumentsModifyQCHold = 112,
  DocumentsViewArchive = 113,
  DocumentsDownloadArchive = 114,
  DocumentsPrintArchive = 115,
  DocumentsModifyArchive = 116,
  DocumentsApproveArchive = 117,
  DocumentsModifyDemographicsInbox = 150,
  DocumentsModifyDemographicsQCHold = 151,
  DocumentsModifyDemographicsArchive = 152,

  ManageAccount = 200,
  ManageAccountRoles = 201,
  ManageLocations = 202,
  ManageContacts = 203,
  EditUser = 204,
  ManageVTUsers = 205,
  ManageReports = 206,
  ManageReportAccess = 207,
  CreateNewMessage = 220,

  ResetPassword = 231,
  UploadVoiceFiles = 255
}

export type TWedDUser = {
  userId: string;
  accountId: string;
  contactId: number;
  firstName: string;
  middleInitial: string;
  lastName: string;
  isProvider: boolean;
  email: string; //contact email
  mail: string; //entra Id
  landingPage: string;
  mobileApp: string;
  inboxJobView: number;
  qcHoldFilter: number;
  privileges: WebDPrivilege[];
  authorizedProviders: number[];
  authorizedLocations: number[];
};

export class WebDUser {
  user: TWedDUser;
  constructor(user: TWedDUser) {
    this.user = user;
  }

  isInternalUser() {
    return this.user.accountId.toUpperCase() === "TD";
  }

  shortName = () => `${this.user.firstName.charAt(0)}${this.user.lastName.charAt(0)}`;

  displayName = () => `${this.user.firstName} ${this.user.lastName}`;

  hasPrivilege(privilege: WebDPrivilege) {
    return this.user.privileges.some(p => p === privilege);
  }

  hasAnyPrivilege(privileges: WebDPrivilege[]) {
    return privileges.some(privilege => this.user.privileges.some(p => p === privilege));
  }
}
